"use strict";
// @ts-ignore
try {
    self['workbox:broadcast-update:6.5.0'] && _();
}
catch (e) { }
